import defaultValue from "./UISlice";

export default defaultValue;
export * from "./UISlice";
